import _ADDRESS_VALIDATION_STATUSES from '~/server_shared/generated-types/ADDRESS_VALIDATION_STATUSES';
import CONTACT_VALIDATION_TYPES from '~/server_shared/generated-types/CONTACT_VALIDATION_TYPES';
import type { GbgAddressRetrieveResponseGbgAddressRetrieveValidation } from '~/server_shared/openapi/data-contracts';

export type AddressValidationStatus = NonNullable<GbgAddressRetrieveResponseGbgAddressRetrieveValidation['status']>;

// `satisfies` is a drift guard: it fails tsc if enums.json (the generated enum)
// and the backend Pydantic status Literal (via the OpenAPI contract) fall out of
// sync — so a new status must be added to both sides.
export const ADDRESS_VALIDATION_STATUSES = _ADDRESS_VALIDATION_STATUSES satisfies Record<
  string,
  AddressValidationStatus
>;

// Statuses that represent an already-validated address: editing reverts them and
// they don't require a manual-override reason.
export const REVERTABLE_STATUSES: AddressValidationStatus[] = [
  ADDRESS_VALIDATION_STATUSES.VERIFIED,
  ADDRESS_VALIDATION_STATUSES.VERIFIED_CORRECTED,
  ADDRESS_VALIDATION_STATUSES.MANUAL_OVERRIDE,
];

export const ADDRESS_VALIDATION_TYPE = CONTACT_VALIDATION_TYPES.ADDRESS;
